<div class="p-dynamic-dialog-body">
    <div class="flex-body flex-column">
        <div class="form-horizontal">
            <div class="flex-body flex-column m-b-24">
                <div class="m-b-8">{{'vbeiFavOrderName' | translate}}*</div>
                <input type="text" pInputText id="favOrderName" maxlength="50" [(ngModel)]="favOrderName"
                    (input)="isMandatoryMissing=false" (blur)="isValid()"
                    [ngClass]="{'has-error': isMandatoryMissing}" />
                <span *ngIf="isMandatoryMissing" class="invalid-msg">{{'vbeiFillMandatoryFields' | translate}}</span>
            </div>
            <div class="flex-body flex-column m-b-24" *ngIf="!isInternalUser">
                <!-- <p-checkbox class="m-b-12" name="includeAttachments" value="Include attachments" label="Include attachments"></p-checkbox> -->
                <p-radioButton class="m-b-12" name="availableTo" [value]="false" [(ngModel)]="isShared"
                    label="{{'vbeiAvailableOnlyMe' | translate}}">
                </p-radioButton>
                <p-radioButton name="availableTo" [value]="true" [(ngModel)]="isShared"
                    label="{{'vbeiAvailableatAccount' | translate}}">
                </p-radioButton>
            </div>
            <div *ngIf="isInternalUser">
                <span>{{'vbeiFavoriteOrderAvailableToAllMessage' | translate}}</span>
            </div>
        </div>
    </div>
</div>
<div class="p-dynamic-dialog-footer">
    <div class="flex-body">
        <div class="align-right">
            <button type="button" pButton (click)="submit()" label="{{'vbeiSave' | translate}}" pButton class="m-r-12"
                [disabled]="!favOrderName || isMandatoryMissing"></button>
            <button type="button" pButton class="p-button-tertiary" (click)="close()" label="{{'vbeiCancel' | translate}}"></button>
        </div>
    </div>
</div>